document.documentElement.classList.remove('no-js');

const rootPath = () => window.Shopify?.routes?.root || '/';

const openDialog = (dialog) => {
  if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
};

const renderCartDrawer = async (open = true) => {
  const current = document.querySelector('[data-cart-drawer]');
  if (!current) return;
  const sectionId = current.dataset.sectionId;
  const sectionUrl = new URL(rootPath(), window.location.origin);
  sectionUrl.searchParams.set('sections', sectionId);
  const response = await fetch(sectionUrl, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('カートを更新できませんでした。');
  const sections = await response.json();
  const sectionHtml = sections?.[sectionId];
  if (!sectionHtml) throw new Error('カートの表示を更新できませんでした。');
  const page = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const nextDrawer = page.querySelector('[data-cart-drawer]');
  const nextCartButton = page.querySelector('.header-cart');
  const currentCartButton = document.querySelector('.header-cart');
  if (nextCartButton && currentCartButton) currentCartButton.replaceWith(nextCartButton);
  if (!nextDrawer) throw new Error('カートの表示を更新できませんでした。');
  current.replaceWith(nextDrawer);
  if (open) requestAnimationFrame(() => openDialog(nextDrawer));
};

const updateCartLine = async (line, quantity) => {
  const drawer = document.querySelector('[data-cart-drawer]');
  drawer?.classList.add('is-loading');
  try {
    const response = await fetch(`${rootPath()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    if (!response.ok) throw new Error('Unable to update cart.');
    await renderCartDrawer(true);
  } catch (error) {
    drawer?.classList.remove('is-loading');
    const status = drawer?.querySelector('[data-cart-status]');
    if (status) {
      status.classList.remove('visually-hidden');
      status.textContent = error.message;
    }
  }
};

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || !document.querySelector('[data-cart-drawer]')) return;
  event.preventDefault();
  const submitButton = event.submitter || form.querySelector('[type="submit"]');
  const buyNow = Boolean(event.submitter?.matches('[data-buy-now]'));
  submitButton?.setAttribute('disabled', '');
  let itemAdded = false;
  try {
    const response = await fetch(`${rootPath()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) {
      const payload = await response.json();
      throw new Error(payload.description || 'Unable to add item to cart.');
    }
    itemAdded = true;
    if (buyNow) {
      window.location.assign(`${rootPath()}checkout`);
      return;
    }
    await renderCartDrawer(true);
  } catch (error) {
    if (itemAdded) {
      window.location.assign(`${rootPath()}cart`);
      return;
    }
    const status = form.querySelector('[role="alert"]');
    if (status) status.textContent = error.message;
    else window.alert(error.message);
  } finally {
    submitButton?.removeAttribute('disabled');
  }
});

document.addEventListener('change', (event) => {
  const quantity = event.target.closest('[data-cart-quantity]');
  if (quantity) updateCartLine(quantity.dataset.line, quantity.value);
});

document.addEventListener('click', (event) => {
  const remove = event.target.closest('[data-cart-remove]');
  if (remove) {
    updateCartLine(remove.dataset.line, 0);
    return;
  }
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    menu.hidden = expanded;
    document.body.style.overflow = expanded ? '' : 'hidden';
    return;
  }
  const menuClose = event.target.closest('[data-menu-close]');
  if (menuClose) {
    const menu = document.getElementById(menuClose.dataset.menuClose);
    if (menu) menu.hidden = true;
    document.querySelector(`[aria-controls="${menuClose.dataset.menuClose}"]`)?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    return;
  }
  const dialogOpen = event.target.closest('[data-dialog-open]');
  if (dialogOpen) {
    openDialog(document.getElementById(dialogOpen.dataset.dialogOpen));
    return;
  }
  const dialogClose = event.target.closest('[data-dialog-close]');
  if (dialogClose) {
    dialogClose.closest('dialog')?.close();
    return;
  }
  const filterOpen = event.target.closest('[data-filter-drawer-open]');
  if (filterOpen) {
    document.querySelector('[data-filter-drawer]')?.classList.add('is-open');
    document.querySelector('.collection-filter-overlay')?.classList.add('is-open');
    filterOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    return;
  }
  if (event.target.closest('[data-filter-drawer-close]')) {
    document.querySelector('[data-filter-drawer]')?.classList.remove('is-open');
    document.querySelector('.collection-filter-overlay')?.classList.remove('is-open');
    document.querySelector('[data-filter-drawer-open]')?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
});

document.addEventListener('click', (event) => {
  const dialog = event.target.closest('dialog');
  if (dialog && event.target === dialog) dialog.close();
});

const selectProductMedia = (section, mediaId, scroll = false) => {
  const gallery = section.querySelector('[data-product-gallery]');
  if (!gallery || !mediaId) return;
  gallery.querySelectorAll('[data-media-id]').forEach((media) => {
    const active = media.dataset.mediaId === String(mediaId);
    media.classList.toggle('is-active', active);
    if (window.matchMedia('(min-width: 750px)').matches) media.hidden = !active;
    if (!active) media.querySelectorAll('video').forEach((video) => video.pause());
    if (active && scroll && window.matchMedia('(max-width: 749px)').matches) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
  gallery.querySelectorAll('[data-media-target]').forEach((button) => button.setAttribute('aria-current', String(button.dataset.mediaTarget === String(mediaId))));
};

const initProductSection = (section) => {
  if (!section || section.dataset.productReady) return;
  section.dataset.productReady = 'true';
  const variantData = JSON.parse(section.querySelector('[data-variant-data]')?.textContent || '[]');
  const labels = JSON.parse(section.querySelector('[data-product-labels]')?.textContent || '{}');
  const syncMobileMedia = () => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    section.querySelectorAll('[data-media-id]').forEach((media) => { media.hidden = mobile ? false : !media.classList.contains('is-active'); });
  };
  syncMobileMedia();
  window.matchMedia('(max-width: 749px)').addEventListener('change', syncMobileMedia);
  section.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-media-target]');
    if (thumbnail) selectProductMedia(section, thumbnail.dataset.mediaTarget, true);
  });
  section.addEventListener('change', (event) => {
    if (!event.target.closest('[data-variant-picker]')) return;
    const selected = section.querySelector('[data-variant-picker] select')?.value || section.querySelector('[data-variant-picker] input:checked')?.value || event.target.value;
    const variant = variantData.find((item) => String(item.id) === String(selected));
    if (!variant) return;
    const price = section.querySelector('[data-product-price]');
    if (price) price.innerHTML = variant.compare_price ? `<span class="price"><s>${variant.compare_price}</s> ${variant.price}</span>` : `<span class="price">${variant.price}</span>`;
    const inventory = section.querySelector('[data-product-inventory]');
    if (inventory) inventory.textContent = variant.available ? labels.in_stock : labels.sold_out;
    const sku = section.querySelector('[data-product-sku]');
    if (sku) sku.textContent = variant.sku || '';
    const addButton = section.querySelector('[data-add-to-cart]');
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
    }
    if (variant.media_id) selectProductMedia(section, variant.media_id, true);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  });
};

document.querySelectorAll('[data-product-section]').forEach(initProductSection);
document.addEventListener('shopify:section:load', (event) => initProductSection(event.target.querySelector('[data-product-section]')));

const initFeaturedCarousel = (viewport) => {
  if (!viewport || viewport.dataset.carouselReady) return;
  const track = viewport.querySelector('.featured-banners__track');
  const firstSet = viewport.querySelector('.featured-banners__set');
  const firstCard = viewport.querySelector('.featured-banner');
  if (!track || !firstSet || !firstCard) return;
  viewport.dataset.carouselReady = 'true';
  viewport.classList.add('is-enhanced');
  let paused = viewport.dataset.autoscroll !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let dragging = false;
  let moved = false;
  let startX = 0;
  let startScroll = 0;
  let previousTime = performance.now();
  let resumeTimer;
  const gap = () => parseFloat(getComputedStyle(track).gap) || 0;
  const syncSetWidths = () => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const columns = Math.max(Number(viewport.dataset.columns) || 4, 1);
    const setGap = gap();
    const cardWidth = mobile ? Math.min(window.innerWidth * 0.84, 360) : (viewport.clientWidth - setGap * (columns - 1)) / columns;
    viewport.querySelectorAll('.featured-banners__set').forEach((set) => {
      const cards = set.querySelectorAll('.featured-banner');
      cards.forEach((card) => { card.style.flexBasis = `${cardWidth}px`; });
      const setWidth = cards.length * cardWidth + Math.max(cards.length - 1, 0) * setGap;
      set.style.width = `${setWidth}px`;
    });
  };
  syncSetWidths();
  window.addEventListener('resize', syncSetWidths);

  const step = () => firstCard.getBoundingClientRect().width + gap();
  const loopWidth = () => firstSet.getBoundingClientRect().width + gap();
  const snap = () => viewport.scrollTo({ left: Math.round(viewport.scrollLeft / step()) * step(), behavior: 'smooth' });

  const animate = (time) => {
    const elapsed = Math.min(time - previousTime, 50);
    previousTime = time;
    if (!paused && !dragging) {
      const duration = Math.max(Number(viewport.dataset.duration) || 32, 1) * 1000;
      viewport.scrollLeft += loopWidth() * elapsed / duration;
      if (viewport.scrollLeft >= loopWidth()) viewport.scrollLeft -= loopWidth();
    }
    requestAnimationFrame(animate);
  };

  viewport.addEventListener('pointerenter', () => {
    clearTimeout(resumeTimer);
    paused = true;
    snap();
  });
  viewport.addEventListener('pointerleave', () => {
    if (dragging) return;
    snap();
    resumeTimer = setTimeout(() => { paused = viewport.dataset.autoscroll !== 'true'; }, 320);
  });
  viewport.addEventListener('pointerdown', (event) => {
    dragging = true;
    moved = false;
    paused = true;
    startX = event.clientX;
    startScroll = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture(event.pointerId);
  });
  viewport.addEventListener('pointermove', (event) => {
    if (dragging) {
      const distance = event.clientX - startX;
      moved = moved || Math.abs(distance) > 5;
      viewport.scrollLeft = startScroll - distance;
      if (viewport.scrollLeft <= 0) {
        viewport.scrollLeft += loopWidth();
        startScroll = viewport.scrollLeft + distance;
      } else if (viewport.scrollLeft >= loopWidth()) {
        viewport.scrollLeft -= loopWidth();
        startScroll = viewport.scrollLeft + distance;
      }
      return;
    }
  });
  const finishDrag = (event) => {
    if (!dragging) return;
    dragging = false;
    viewport.classList.remove('is-dragging');
    if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    snap();
  };
  viewport.addEventListener('pointerup', finishDrag);
  viewport.addEventListener('pointercancel', finishDrag);
  viewport.addEventListener('click', (event) => {
    if (moved) {
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }
  }, true);
  viewport.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    paused = true;
    viewport.scrollBy({ left: event.key === 'ArrowRight' ? step() : -step(), behavior: 'smooth' });
  });
  requestAnimationFrame(animate);
};

document.querySelectorAll('[data-featured-carousel]').forEach(initFeaturedCarousel);
document.addEventListener('shopify:section:load', (event) => initFeaturedCarousel(event.target.querySelector('[data-featured-carousel]')));

const initProductSlider = (slider) => {
  if (!slider || slider.dataset.initialized === 'true') return;
  const viewport = slider.querySelector('[data-product-slider-viewport]');
  const previous = slider.querySelector('[data-product-slider-previous]');
  const next = slider.querySelector('[data-product-slider-next]');
  if (!viewport || !previous || !next) return;
  slider.dataset.initialized = 'true';

  const updateControls = () => {
    const maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
    const hasOverflow = maxScroll > 2;
    previous.hidden = !hasOverflow || viewport.scrollLeft <= 2;
    next.hidden = !hasOverflow || viewport.scrollLeft >= maxScroll - 2;
  };
  const cardStep = () => {
    const card = viewport.querySelector('.card');
    if (!card) return viewport.clientWidth;
    const gap = parseFloat(getComputedStyle(viewport).columnGap || getComputedStyle(viewport).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  };
  const move = (direction) => viewport.scrollBy({ left: direction * cardStep(), behavior: 'smooth' });

  const updateArrowPosition = () => {
    const rect = slider.getBoundingClientRect();
    const arrowRadius = 24;
    const viewportCenter = window.innerHeight / 2;
    const visibleCenter = Math.min(Math.max(viewportCenter, rect.top + arrowRadius), rect.bottom - arrowRadius);
    slider.style.setProperty('--arrow-top', `${visibleCenter - rect.top}px`);
  };

  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  viewport.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('scroll', updateArrowPosition, { passive: true });
  window.addEventListener('resize', updateArrowPosition, { passive: true });
  viewport.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    move(event.key === 'ArrowRight' ? 1 : -1);
  });
  new ResizeObserver(updateControls).observe(viewport);
  new ResizeObserver(updateArrowPosition).observe(slider);
  requestAnimationFrame(() => {
    updateControls();
    updateArrowPosition();
  });
};

document.querySelectorAll('[data-product-slider]').forEach(initProductSlider);
document.addEventListener('shopify:section:load', (event) => initProductSlider(event.target.querySelector('[data-product-slider]')));

const animatedElements = document.querySelectorAll('[data-animate]');
if (animatedElements.length && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }), { rootMargin: '0px 0px -8% 0px' });
  animatedElements.forEach((element) => observer.observe(element));
} else animatedElements.forEach((element) => element.classList.add('is-visible'));
